import { render, staticRenderFns } from "./GoodsDialog.vue?vue&type=template&id=64ea970a&scoped=true&"
import script from "./GoodsDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDialog.vue?vue&type=style&index=0&id=64ea970a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea970a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ea970a')) {
      api.createRecord('64ea970a', component.options)
    } else {
      api.reload('64ea970a', component.options)
    }
    module.hot.accept("./GoodsDialog.vue?vue&type=template&id=64ea970a&scoped=true&", function () {
      api.rerender('64ea970a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/GoodsDialog.vue"
export default component.exports